import useSWR from 'swr'
import {useRails} from '../contexts/rails'
import {fetcher, putHeaders} from '../../api/fetcher'

/**
 * Custom hook for checking if access token is fresh or stale on component mount
 * @param {string|number} supplierId - The supplier ID to check token freshness for
 * @returns {Object} Object containing checking state, error, and checked flag
 */
export const useTokenFreshnessCheck = (supplierId) => {
  const {authenticityToken} = useRails()

  const {data, error, isLoading} = useSWR(
    `/api/suppliers/${supplierId}/refresh_access_token/check`,
    (url) => fetcher(url, putHeaders({authenticityToken})),
    {
      // Run only once on mount - disable all revalidation
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      revalidateIfStale: false,
      refreshInterval: 0,
    },
  )

  return {
    isChecking: isLoading,
    error,
    isChecked: !!data,
  }
}
